import type { ElementAddress } from 'editor/src/store/design/types';
import type { ThunkAction, ThunkDispatch } from 'editor/src/store/hooks';

const applyToMultipleMediaOperation =
  <R>(elementAddresses: ElementAddress[], operation: (elementAddress: ElementAddress) => ThunkAction<R>) =>
  (dispatch: ThunkDispatch) =>
    elementAddresses.map((ea) => dispatch(operation(ea)));

export default applyToMultipleMediaOperation;
